<template>
  <div class="h-full flex items-center justify-center">
    <Line
      v-if="data && !loading"
      :data="data"
      :options="{
        parsing: false,
        interaction: {
          intersect: false,
          mode: 'index',
        },
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          x: {
            type: 'time',
            time: {
              minUnit: 'day',
              tooltipFormat: 'MMM d, yyyy',
            },
          },
          y: {
            beginAtZero: true,
            ticks: {
              precision: 0,
            },
          },
        },
      }"
    />
    <LoadingSpinner v-else />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { Line } from "vue-chartjs";

import LoadingSpinner from "@/components/LoadingSpinner.vue";

const props = defineProps({
  stats: { type: Object },
  loading: { type: Boolean, required: true },
});

const data = computed(() => {
  if (!props.stats) {
    return;
  }
  return {
    datasets: [
      {
        label: "Rejected",
        backgroundColor: "rgb(255, 100, 103, 0.7)",
        borderColor: "rgb(193, 0, 7, 1)",
        fill: true,
        data: props.stats?.rejected_counts,
        pointHitRadius: 8,
        pointRadius: 0,
      },
      {
        label: "Accepted (with edits)",
        backgroundColor: "rgb(142, 197, 255, 0.7)",
        borderColor: "rgb(21, 93, 252, 1)",
        fill: true,
        data: props.stats?.edited_and_accepted_counts,
        pointHitRadius: 8,
        pointRadius: 0,
      },
      {
        label: "Accepted (no edits)",
        backgroundColor: "rgb(94, 233, 181, 0.7)",
        borderColor: "rgb(0, 153, 102, 1)",
        fill: true,
        data: props.stats?.accepted_counts,
        pointHitRadius: 8,
        pointRadius: 0,
      },
      {
        label: "Created",
        backgroundColor: "rgb(254, 230, 133, 0.7)",
        borderColor: "rgb(255, 185, 0, 1)",
        fill: true,
        data: props.stats?.created_counts,
        pointHitRadius: 8,
        pointRadius: 0,
      },
    ],
  };
});
</script>
